// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".carousel__slide[data-v-b51d3956]{width:20%}@media only screen and (max-width:480px){.promotion_banner_card[data-v-b51d3956]{min-height:65vh}}@media only screen and (min-width:1024px){.promotion_banner_card[data-v-b51d3956]{height:60vh}}", ""]);
// Exports
module.exports = exports;
